export enum THGTagCategory {
    DEFAULT = 'default',
    ERROR = 'error',
}
